angular.module('unica_approvation_list.approvation_list_services')

.factory('ApprovationListCreateService', function ($http, getBaseApiURL) {

	var approvationListCreateService = {};

	approvationListCreateService.create = function ( approvationListData ) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/approvation-list/create',
			data: approvationListData
		}).then(function(result) {

			if ( result ) {
				return result.data.approvation_list;
			}

		});

	};

	return approvationListCreateService;
});